import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { firebaseConnect } from 'react-redux-firebase';

import * as UI from '../components'

class Storefront extends React.Component {
  getChildContext() {
    return {
      theme: this.props.storefront ? this.props.storefront.theme || {} : null,
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.storefront) {
      document.title = `${nextProps.storefront.name} Token Sale`
    }

    const {
      addStorefrontToVisited,
      createStorefrontsVisited,
      identifyUser,
      profile,
      storefrontId,
    } = nextProps

    if (profile.isEmpty) return

    if (!this.props.profile) return

    if (!this.props.profile.isLoaded && profile.isLoaded) {
      // send updated user info to segment once the profile is loaded
      identifyUser(profile, storefrontId)

      if (!profile.storefrontsVisited) {
        createStorefrontsVisited()
      } else if (!profile.storefrontsVisited[storefrontId]) {
        addStorefrontToVisited(profile.storefrontsVisited)
      }
    }
  }

  render() {
    const { children, ...props } = this.props
    return props.storefrontLoaded ? (
      React.cloneElement(children, props)
    ) : (
      <UI.Loader />
    )
  }
}

Storefront.childContextTypes = {
  theme: PropTypes.object,
}

const watches = () => [{ path: `/storefronts` }]

const selectors = createStructuredSelector({
  storefronts: ({ firebase }) => firebase.data.storefronts,
  storefront: ({ firebase }) => ({
    ...(firebase.data.storefronts || {})[process.env.REACT_APP_STOREFRONT_ID],
  }),
  storefrontLoaded: ({ firebase }) => firebase.requested.storefronts,
  storefrontId: () => process.env.REACT_APP_STOREFRONT_ID,
  profile: ({ firebase }) => ({ ...(firebase.profile || {}), uid: firebase.auth && firebase.auth.uid }),
  tranches: ({ firebase }) => firebase.data.tranches || {},
})

const actions = (dispatch, props) => ({
  createStorefrontsVisited: async () => {
    try {
      let storefrontsVisited = {}
      storefrontsVisited[process.env.REACT_APP_STOREFRONT_ID] = true
      await props.firebase.updateProfile({ storefrontsVisited: storefrontsVisited })
    } catch (error) {
      console.log("Error: ", error)
    }
  },

  addStorefrontToVisited: async (storefrontsVisited) => {
    try {
      storefrontsVisited[process.env.REACT_APP_STOREFRONT_ID] = true
      await props.firebase.updateProfile({ storefrontsVisited: storefrontsVisited })
    } catch (error) {
      console.log("Error: ", error)
    }
  },

  identifyUser: async ({ email }, storefrontId) => {
    dispatch({
      type: 'IDENTIFY_USER',
      identify: { email, storefrontId },
    })
  },
});

export default compose(
  firebaseConnect(watches),
  connect(selectors, actions),
)(Storefront);



// WEBPACK FOOTER //
// ./src/screens/Storefront.js